export const truncateString = (str: string, limit: number, breakword = true) => {
  const newStr = breakword
    ? // Splitting by word+punctuations
      str.split(' ').reduce((acc, word, _, arr) => {
        const currentAcc = acc ? [acc, word].join(' ') : word

        // Returning successfully if limit not reached
        if (currentAcc.length <= limit) {
          return currentAcc
        } else {
          // Limit reached, early break and splice out
          arr.splice(0, arr.length)
          return acc
        }
      })
    : str.substring(0, limit)

  return `${newStr}...`
}
